import { RemoveRedEye } from "@mui/icons-material"
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from "@mui/material"
import strings from "../../Globalization"

const PreviewTopics = ({
	data, activeRecord, open, setOpen
}) => {
	const publishedTopics = []
	const subscribedTopics = []
	const serialNumber = "${serialNumber}"
	const equipmentType = data.EquipmentType || "${EquipmentType}"
	const linkToTrackingSystems = "${LinkToTrackingSystems}"
	const hospital = activeRecord?.combos?.Hospital.find(hospital => (hospital.LookupId === data.HospitalName))

	for (const item of data.Subscription) {
		let topic = `${hospital?.HospitalUniqueId}/`
		const [wildCardTopicName, getWildCard] = item.split("/")
		const topicName = item.split('+/').pop(1)
		const isWildCard = getWildCard === "#"
		const topicGroups = ["data", "cmd", "tdata"]
		topic += isWildCard && wildCardTopicName === 'data' || wildCardTopicName === 'tdata' || wildCardTopicName === 'cmd' ? `${wildCardTopicName}/#` : isWildCard && wildCardTopicName !== 'data' ? `${wildCardTopicName}/+/+/+` : topicName === 'data' ? `${topicName}/+/+` : `${topicName}`
		if (topicName === 'data' && data.SubDataPermission.length) {
			data.SubDataPermission.forEach(value => {
				subscribedTopics.push(topic + `/${value}`)
			}
			)
		}
		if (topicName === 'cmd' && data.SubCmdPermission.length) {
			data.SubCmdPermission.forEach(value => {
				const newTopic = value === "cyclefileres" ? `${hospital?.HospitalUniqueId}/${topicName}/${equipmentType}/${linkToTrackingSystems}/${value}` : `${hospital?.HospitalUniqueId}/${topicName}/${equipmentType}/${serialNumber}/${value}`

				subscribedTopics.push(newTopic)
			})
		}
		if (topicName === 'tdata' && data.SubTDataPermission.length) {
			data.SubTDataPermission.forEach(value => {
				subscribedTopics.push(topic + `/${equipmentType}/${serialNumber}/${value}`)
			})

		} if (isWildCard && topicGroups.includes(wildCardTopicName)) {
			subscribedTopics.push(topic)
		}
		if (topicName === 'heartbeat') {
			subscribedTopics.push(`$SYS/+/heartbeat`)
		}
		if (isWildCard && !topicGroups.includes(wildCardTopicName) && wildCardTopicName !== 'heartbeat') {
			subscribedTopics.push(topicName)
		}
		else {
			!topicGroups.includes(topicName) && !isWildCard && wildCardTopicName !== 'heartbeat' && subscribedTopics.push(topicName)
		}

	}

	for (const item of data.Publish) {
		let topic = `${hospital?.HospitalUniqueId}/`
		const [wildCardTopicName, getWildCard] = item.split("/")
		const topicName = item.split('+/').pop(1)
		const isWildCard = getWildCard === "#"
		const topicGroups = ["data", "cmd", "tdata"]
		topic += isWildCard && wildCardTopicName === 'data' || wildCardTopicName === 'tdata' || wildCardTopicName === 'cmd' ? `${wildCardTopicName}/#` : isWildCard && wildCardTopicName === 'TransactionSync' ? `${wildCardTopicName}/#` : isWildCard && wildCardTopicName !== 'TransactionSync' ? `${wildCardTopicName}/+/+/+` : topicGroups.includes(topicName) ? `${topicName}/${equipmentType}/${serialNumber}` : `${topicName}`

		if (topicName === 'data' && data.DataPermission.length) {
			data.DataPermission.forEach(value => {
				publishedTopics.push(topic + `/${value}`)
			}
			)
		} if (topicName === 'cmd' && data.CmdPermission.length) {
			data.CmdPermission.forEach(value => {
				const newTopic = value === "cyclefileres" ? `${hospital?.HospitalUniqueId}/${topicName}/${equipmentType}/${linkToTrackingSystems}/${value}` : `${hospital?.HospitalUniqueId}/${topicName}/${equipmentType}/${serialNumber}/${value}`

				publishedTopics.push(newTopic)

			})
		}
		if (topicName === 'tdata' && data.TDataPermission.length) {
			data.TDataPermission.forEach(value => {
				publishedTopics.push(topic + `/${value}`)
			})
		}
		if (isWildCard && topicGroups.includes(wildCardTopicName)) {
			publishedTopics.push(topic)
		}
		if (isWildCard && !topicGroups.includes(wildCardTopicName)) {
			publishedTopics.push(topic)
		}
		else {
			!topicGroups.includes(topicName) && !isWildCard && publishedTopics.push(topic)
		}
	}

	return (
		<Box sx={{ marginLeft: 5 }}>
			<Dialog open={open} onClose={() => (setOpen(false))}
				sx={{
					zIndex: theme => theme.zIndex.tooltip,
					'& .MuiDialog-paper': {
						maxWidth: '55vw !important',
						width: '55vw !important',
						maxHeight: '80vh !important'
					},
					'& .MuiDialogContentText-root': {
						border: (theme) => `1px solid ${theme.palette.divider}`,
						borderRadius: (theme) => theme.spacing(0.5),
						backgroundColor: 'action.selected',
						padding: (theme) => theme.spacing(0, 2),
						'& pre': {
							overflowX: 'auto'
						}
					}
				}}
				disableEscapeKeyDown
			>
				<DialogTitle sx={{ display: 'flex', flexDirection: 'row' }}>
					<Typography variant="body1" color="primary" sx={{ flex: 1 }}>
						{strings.BrokerTopicsPreview}
					</Typography>
					<Button variant="contained" onClick={() => (setOpen(false))} title={strings.Close} color="error" size="small" sx={{
						px: 1,
						fontSize: 14,
						textTransform: 'uppercase',
						fontWeight: 'bold',
					}}
					>{strings.Close}</Button>
				</DialogTitle>
				<Divider />
				<DialogContent style={{ backgroundColor: '#f0f0f0' }}>
					<Box padding={1} marginTop={1} bgcolor="#1976D2">
						<Typography color="whitesmoke" textAlign="center">{strings.SubscribedTopics}</Typography>
					</Box>
					<Box padding={1}>
						{subscribedTopics.map((topic, index) => (
							<Typography key={index}>{topic}</Typography>
						))}
					</Box>
					<Box padding={1} bgcolor="#1976D2">
						<Typography color="whitesmoke" textAlign="center">{strings.PublishedTopics}</Typography>
					</Box>
					<Box padding={1}>
						{publishedTopics.map((topic, index) => (
							<Typography key={index}>{topic}</Typography>
						))}
					</Box>
				</DialogContent>

			</Dialog>
			<Button onClick={() => (setOpen(true))} color="info" startIcon={<RemoveRedEye />} variant='contained'>{strings.BrokerTopicsPreview}</Button>
		</Box>
	)
}

export default PreviewTopics